
import './DataRuns.css'
import * as React from "react";
import ControlPanelContainer from '../../container/ControlPanelContainer';
//import { getGraphInfo } from '../../service/dataService';
import GridLayout from "react-grid-layout";
import InfoViewContainer from '../../container/InfoViewContainer';
import DescriptionViewContainer from '../../container/DescriptionViewContainer'
import { assert_key,getLayoutConfig, SystemDesign } from '../../helper';
import { Divider, Typography } from 'antd';
const { Title, Paragraph, Text, Link } = Typography;



export interface IProps {
    dataset_id : number | null,
    contentWidth:number,
    contentHeight:number,
}
export interface IState {
    layout_config: any,
    screenWidth: number,
    screenHeight: number,
    enableStatic: boolean
}

export default class DataRuns extends React.Component<IProps, IState>{
    public InfoViewRef:any;
    public ControlPanelRef: any;
    public DescriptionRef: any;
    public viewname_to_ref:any;

    constructor(props:IProps) {
        super(props);
        this.onResizeStop = this.onResizeStop.bind(this);
        this.getLayoutConfigWithName = this.getLayoutConfigWithName.bind(this);
        this.getCurrentLayoutConfig = this.getCurrentLayoutConfig.bind(this);
        this.getViewRefWithName = this.getViewRefWithName.bind(this);
        this.InfoViewRef = React.createRef();
        this.ControlPanelRef = React.createRef();
        this.viewname_to_ref = {
            "Description": this.DescriptionRef,
            "ControlPanel": this.ControlPanelRef,
            "InfoView": this.InfoViewRef,
        }

        this.state = {
            layout_config: null,
            screenWidth : 0,
            screenHeight: 0,
            enableStatic: true
        }


        //this.resize.bind(this);
        // Flow:
        // 1. Constructor
        // 2. componentWillMount()
        // 3. render()
        // 4. componentDidMount()
        // If props update:
        // 4.1 componentWillReceiveProps(nextProps : IProps), then goto 5.
        // If States update
        // 5. shouldComponentUpdate() if return false, then no rerendering.
        // 6. if True, then componentWillUpdate
        // 7. render()
        // 8. componentDidUpdate
        // If Unmount, then componentWillUnmount()
    }


     // When the view is mounted, it will be executed.
     componentDidMount(){
        //window.addEventListener('resize', this.onResize)
         this.setState({
             layout_config: this.getWholeLayoutConfig(),
             screenHeight: window.innerHeight,
             screenWidth: window.innerWidth
         })
     }

     public getViewRefWithName(name:string){
         if(Object.keys(this.viewname_to_ref).indexOf(name) >= 0){
            return this.viewname_to_ref[name];
         }
     }
     // Get width and height from view name. 
     public getLayoutConfigWithName(name:string){
         let width = 0;
         let height = 0;
         let viewref = this.getViewRefWithName(name)
         if(viewref){
            width = viewref.current.offsetWidth;
            height = viewref.current.offsetHeight;
         }
         return {
             "width":width,
             "height":height
         }
     }
     // Get the whole layout config. 
     public getWholeLayoutConfig(){
        let viewName = Object.keys(this.viewname_to_ref); 
        let layout_config:any = {};
        viewName.forEach((d:any)=>{
            layout_config[d] = this.getLayoutConfigWithName(d);
        })
        return layout_config;
     }

     // Get layout config from view name. 
     public getCurrentLayoutConfig(name:string){
         let layout_config = this.state.layout_config;
        if(layout_config){
            if(layout_config[name]){
                return layout_config[name];
            }else{
                return null;
            }
        }else{
            return null;
        }
     }

     // Handling the changing of states or props.
     componentDidUpdate(prevProps:IProps, prevState:IState) {
        //console.log('Component did update!')
        // If the dataset_id has been changed. 
        if(prevProps.dataset_id !== this.props.dataset_id){
            // If the id is valid. 
            if( this.props.dataset_id  && this.props.dataset_id>=0){
                // Set to a dummy case.
                this.setState({

                })
            }else{
                // Set to a dummy case.
                this.setState({

                })
            }
        }

        // If the window is resized, update the layout config. 
        if(prevProps.contentHeight!==this.props.contentHeight
            || prevProps.contentWidth !== this.props.contentWidth){
                this.setState({
                    layout_config: this.getWholeLayoutConfig()
                })
            }   
        
        
        
     }

    // RESERVED: handling the layout change.
    public onLayoutChange(layout:any){
        console.log("Layout", layout);
    }
    // For react-grid-layout, when the resizing is fixed, the layout configuration should be updated.
    public onResizeStop(layout:any){
        console.log("onResizeStop", layout);
        console.log("Layout", this.getWholeLayoutConfig());
        this.setState({
            layout_config : this.getWholeLayoutConfig()
        })
        //var width = document.getElementById('a').offsetWidth;
    }
    public render() {
        // Rendering. 
        let dataset_id = this.props.dataset_id;
        let generateInfoView = (width:number, height:number) => {
            return <InfoViewContainer 
                width={width}
                height={height}
                />
        }
        let set_enable_static = (value:any) => {
            this.setState({
                enableStatic: value
            })
        }
        let get_enable_static = () => {
            return this.state.enableStatic
        }
        let enableAutoModify = true;
        if(enableAutoModify){
            document.addEventListener("keydown", function(e:any){
                //console.log(e)
                let curr_enableStatic = get_enable_static();
                switch(e.keyCode){
                    case 9: // Tab -- Open the auto layout.
                        if(curr_enableStatic == true){
                            set_enable_static(false);    
                            alert("You have enabled the modified layout. You can press alt to disable it.");    
                        }
                        return;
                    case 18:
                        if(curr_enableStatic == false){

                            set_enable_static(true);
                            alert("You have disabled the modified layout. You can press tab to modify it.")
                        }
                    return;
                }
            });
        }
        

        // layout is an array of objects, see the demo for more complete usage
        
        let enableStatic = this.state.enableStatic;  // If enabled static, the layout cannot be manually configured.
        if(!enableAutoModify){
            enableStatic = true;
        }
        let max_row_num = Math.floor(this.props.contentHeight / 40); // Maximum rows in the screen.
        // small width, height: 1707 724
        // big width, height: 2560 1175
        let ControlPanelH = 3;
        let ControlPanelW = 24;
        let SecondLineH = 10;
        let DescriptionH = 10;

        let layout = [
            {i: 'c', x: 0, y: 0, w: ControlPanelW, h: DescriptionH, static:enableStatic}, // Description
            {i: 'a', x: 0, y: DescriptionH, w: ControlPanelW, h: ControlPanelH, static:enableStatic},  // Control Panel
            {i: 'b', x: 0, y: ControlPanelH + DescriptionH, w: ControlPanelW, h: SecondLineH, static:enableStatic}, // Info View
        ];
        
        // Generate Whole Layout.
        let generateSequentialLayout = () => {
            let contentWidth = this.props.contentWidth;
            return <div>
                <div className="IntroViewBox" key="c" ref={this.DescriptionRef}>
                    <DescriptionViewContainer />
                </div>
                <div className="IntroViewBox" key="a" ref={this.ControlPanelRef}>
                <ControlPanelContainer 
                        width={contentWidth}
                        height={100}/>
                </div>
                <div className="IntroViewBox" key="b" ref={this.InfoViewRef}>
                {generateInfoView(
                            contentWidth, 
                            350
                        )}
                </div>
            </div>
        }
        let generateWholeView = () =>{
            let screenwidth = window.innerWidth;
            //let screenheight = window.innerHeight;

            // cols = 24, rowHeight = 30
            return <div><GridLayout className="layout" layout={layout} 
                cols={24} rowHeight={31} width={this.props.contentWidth} onLayoutChange={this.onLayoutChange}
                onResizeStop={this.onResizeStop}>
                    <div className="PanelBox" key="c" ref={this.DescriptionRef}>
                        {(this.getCurrentLayoutConfig("Description"))?<div/>:<div />}
                    </div>
                    <div className="PanelBox" key="a" ref={this.ControlPanelRef}>
                        {(this.getCurrentLayoutConfig("ControlPanel"))?<ControlPanelContainer 
                        width={this.getCurrentLayoutConfig("ControlPanel")["width"]}
                        height={this.getCurrentLayoutConfig("ControlPanel")["height"]}/>:<div />}
                    </div>
                    <div className="PanelBox" key="b" ref={this.InfoViewRef}>
                        {(this.getCurrentLayoutConfig("InfoView"))?generateInfoView(
                            this.getCurrentLayoutConfig("InfoView")["width"], 
                            this.getCurrentLayoutConfig("InfoView")["height"]
                        ):<div />}
                    </div>

                    
                </GridLayout>
                
                </div>
        }
        
        return generateSequentialLayout();
    }
}

